module.exports = "<div class=\"lui-tagfield__wrapper lui-suggestions__menu-wrapper\" tabindex=\"0\">\n  <div class=\"lui-tagfield__tags\">\n    <lui-textfield></lui-textfield>\n  </div>\n  <span class=\"lui-suggestions__menu-placeholder\"></span>\n  <slot></slot>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-tagfield/theme/lui-tagfield.html
// module id = 354
// module chunks = 0 1 4